import React, { Component } from "react";
import { connect } from 'react-redux';
import * as flightActions from '../../../store/actions/index';
import * as uiActions from '../../../store/actions/index';

import Dropdown from './Dropdown/Dropdown';
import SlidingSwitch from '../../UI/SlidingSwitch/SlidingSwitch';

import { animateScroll as scroll } from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import aeroplaneImage from './img/aeroplane.png';
import { switchHeaderView } from '../../../store/actions/index';

class TupleHeader extends Component {

  state = {
    isDropdownOpen: false
  }

  openDropdownHandler = () => this.setState({ isDropdownOpen: true })
  closeDropdownHandler = () => this.setState({ isDropdownOpen: false })
  scrollToTop = () => scroll.scrollToTop();

  render() {
    let filterType = 'Price';
    if (this.props.isPriceActive) {
      filterType = 'Price'
    } else if (this.props.isDurationActive) {
      filterType = 'Duration'
    } else if (this.props.isDepartureActive) {
      filterType = 'Departure'
    } else if (this.props.isArrivalActive) {
      filterType = 'Arrival';
    }
    const colorDark = "var(--color-grey-dark-1)";

    return (
      <div className={`u-flex align-items-center mb-4 mt-0 phone-mt-2 justify-content-between u-lineHeight15Rem`}>
        <div className={`u-phoneShow`}>
          <p className={`u-fontSize13 u-textColorDark u-fontWeightRegular`}><span className={`u-size12x12 u-inlineBlock mr-1`}><img src={aeroplaneImage} alt='Aeroplane' className={`u-block u-width100Percent u-height100Percent`}/></span>{this.props.flightsFound} flights found</p>
        </div>
        <div className={`u-flex align-items-center u-phoneHide`}>
          <p className={`u-textUppercase u-fontWeightMedium u-textColorDark u-fontSize11`}>Non-Stop</p>
          <div className={`ml-2 u-lineHeight1`}>
            <SlidingSwitch onChange={() => this.props.onToggleNonStopFlights()} checked={this.props.selectedStops.includes(0) ? true : false}  />
          </div>
        </div>
        <div className={`mt-0 mb-0 ml-3 mr-3 u-textColorLightest u-phoneHide`}>|</div>
        <div className={`u-flex align-items-center u-phoneHide`}>
          <p className={`u-textUppercase u-fontWeightMedium u-textColorDark u-fontSize11`}>Refundable</p>
          <div className={`ml-2 u-lineHeight1`}>
            <SlidingSwitch onChange={() => this.props.onToggleRefundableFlights()} checked={this.props.refundableArray.includes(1) ? true : false} />
          </div>
        </div>
        <div className={`mt-0 mb-0 ml-3 mr-3 u-textColorLightest u-phoneHide`}>|</div>
        <div className={`u-phoneHide mr-auto`}>
          <a className={`u-fontSize11 u-fontWeightMedium u-cursorPointer u-textColorPrimary u-textUppercase`} onClick={(e) => {
            e.preventDefault();
            this.props.onToggleDesktopFilters();
            this.scrollToTop();
          }}>{!this.props.desktopFilters ? '+ More' : '- Hide'} Filters</a>
        </div>
        <div className={`u-relative u-flex align-items-center`} onMouseEnter={this.openDropdownHandler} onMouseLeave={this.closeDropdownHandler}>
          <p className={`u-textUppercase u-fontWeightMedium u-textColorDark u-fontSize11`}><span className={`u-fontWeightRegular`}>Sort By:&nbsp;</span> {filterType}<span className={`ml-1 u-inlineBlock`} style={{transform: 'rotate(90deg)'}}><FontAwesomeIcon icon="caret-right" color={`${colorDark}`} size="1x" /></span></p>
          { this.state.isDropdownOpen ? <Dropdown /> : null } 
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    desktopFilters: state.ui.desktopFilters,
    isPriceActive: state.flights.priceFilterSelected,
    isDurationActive: state.flights.durationFilterSelected,
    isDepartureActive: state.flights.departureFlightFiltersSelected,
    isArrivalActive: state.flights.arrivalFlightFiltersSelected,
    flightsFound: state.flights.flightsFound,
    refundableArray: state.flights.refundableArray,
    selectedStops: state.flights.selectedStops
  }
}

const matchDispatchToProps = dispatch => {
  return {
    onFilterByPrice: () => dispatch(flightActions.filterByPrice()),
    onFilterByDuration: () => dispatch(flightActions.filterByDuration()),
    onToggleDesktopFilters: () => dispatch(uiActions.toggleDesktopFilters()),
    onSwitchHeaderView: (view) => dispatch(switchHeaderView(view)),
    onToggleRefundableFlights: () => dispatch(flightActions.toggleRefundableFlights()),
    onToggleNonStopFlights: () => dispatch(flightActions.toggleNonStopFlights())
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(TupleHeader);



// WEBPACK FOOTER //
// ./src/components/Flight/TupleHeader/TupleHeader.js